import './error_boundary.less';

import React from 'react';

import ErrorBoundary from './error_boundary.jsx';

const ErrorBoundaryInternal = (props)=>
  <ErrorBoundary {...props} shouldSuggestReporting={true} />;

export default ErrorBoundaryInternal;